import { Link, useLocation } from "react-router-dom";

export const GlobalNav = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');
  
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/vetengine/guided-navigator', label: 'Guided Assistant' },
    { path: '/case-dashboard', label: 'Case Dashboard' },
    { path: '/vetengine', label: 'Legal Engine' },
    { path: '/vha-directives', label: 'VHA Directives' },
    { path: '/vetengine/drug-policy', label: 'Drug Policy' },
    { path: '/vetengine/oversight', label: 'Oversight' },
    { path: '/facility-risk-index', label: 'Risk Index' },
    { path: '/hudvash-directory', label: 'Facility Directory' }
  ];
  
  return (
    <header className="px-4 md:px-8 py-4" style={{ backgroundColor: '#1A4F63' }}>
      <div className="max-w-7xl mx-auto flex flex-wrap justify-center lg:justify-between gap-4 md:gap-6 items-center">
        <Link to="/" className="font-bold text-xl shrink-0" style={{ color: '#FFCC01' }}>
          VETDirect
        </Link>
        <nav className="flex flex-wrap justify-center gap-3 md:gap-4 lg:gap-6 items-center">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="hover:opacity-80 transition-opacity text-sm md:text-base whitespace-nowrap"
              style={{ 
                color: isActive(item.path) ? '#FFCC01' : '#fff',
                fontWeight: isActive(item.path) ? 'bold' : 'normal'
              }}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export const Breadcrumb = ({ items }) => {
  return (
    <div className="text-sm mb-6" style={{ color: '#666' }}>
      {items.map((item, i) => (
        <span key={i}>
          {i > 0 && <span className="mx-2">/</span>}
          {item.link ? (
            <Link to={item.link} className="hover:underline" style={{ color: '#1A4F63' }}>
              {item.label}
            </Link>
          ) : (
            <span style={{ color: '#333', fontWeight: 'bold' }}>{item.label}</span>
          )}
        </span>
      ))}
    </div>
  );
};
